export enum LineStyle {
	Straight = 0,
	LongDash = 1,
	Dash = 2,
	DashedDot = 3,
	Dots = 4,
	SpacedDash = 5
}
